<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">小程序商城</el-breadcrumb-item>
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-form :model="querys" ref="querys" label-width="90px" class="search-form" size="default">
      <el-row>
        <el-form-item label="关键词" prop="keyword">
          <el-col>
            <el-input v-model="querys.keyword" prefix-icon="Search" @keyup.enter="search"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="商品编号" prop="productCode">
          <el-col style="width: 120px">
            <el-input v-model="productCode" @keyup.enter="search"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="" label-width="20px">
          <el-button type="primary" icon="Search" @click="search()">
            搜索
          </el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="toolbar">
      <el-button type="primary" icon="Plus" @click="add()">
        新增
      </el-button>
      <el-button 
        type="primary" 
        icon="Edit" 
        @click="edit(selectedRow)">
        编辑
      </el-button>
      <el-button 
        type="primary" 
        icon="Picture" 
        @click="editImages(selectedRow)">
        编辑商品图片
      </el-button>
      <el-button 
        type="danger" 
        icon="Delete" 
        @click="del(selectedRow)">
        删除
      </el-button>
    </div>

    <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border lazy :load="loadChild"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" size="small" 
      highlight-current-row @current-change="handleCurrentChange">
      <el-table-column label="展开" width="60">
          <template #default="scope">
            <!-- <span>{{ scope.$index + 1 }}</span> -->
          </template>
        </el-table-column>
      <template v-for="item in querys.columns" :key="item.prop || item.type">
        
        <!-- 序号列 -->
        <el-table-column v-if="item.type === 'index'" :type="item.type" :label="item.label" :width="item.width" />
        
        


        <!-- 商品类别列 -->
        <el-table-column v-else-if="item.prop === 'categoryID'" 
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :show-overflow-tooltip="item.showOverflowTooltip"
          :sortable="item.sortable">
          <template #default="scope">
            {{ getCategoryAttribute(scope.row.categoryID) }}
          </template>
        </el-table-column>

        <!-- 其他普通列 -->
        <el-table-column v-else
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :show-overflow-tooltip="item.showOverflowTooltip"
          :sortable="item.sortable" />
      </template>
    </el-table>

    <el-pagination v-model:current-page="querys.page" v-model:page-size="querys.rows" :page-sizes="[10, 20, 50, 100]"
      layout="total, sizes, prev, pager, next, jumper" :total="querys.records" @size-change="sizeHandler"
      @current-change="pageHandler" />

    <static-dialog ref="dialog" class="dialog" :title="dialogTitle" :opened="opened" :ok="submit">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="基本信息" name="basic">
          <el-form :model="forms" :rules="rules" ref="forms" :label-width="labelWidth">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="商品类别" prop="categoryID">
                  <el-select v-model="forms.categoryID" placeholder="请选择商品类别" @change="chooseOption">
                    <el-option v-for="item in categoryData" :key="item.id" :label="item.attribute || item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="商品编号" prop="productCode">
                  <el-input v-model="forms.productCode" autocomplete="off" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16">
                <el-form-item label="商品名称" prop="productName" style="max-width: 95%">
                  <el-input v-model="forms.productName" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="上架时间" prop="startDate">
                    <el-date-picker v-model="forms.startDate" type="datetime" placeholder="选择上架开始时间" style="width: 100%;" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="下架时间" :span="12" prop="endDate">
                    <el-date-picker v-model="forms.endDate" type="datetime" placeholder="选择上架结束时间" style="width: 100%;" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="商品描述" prop="productDesc">
                <el-input type="textarea" v-model="forms.productDesc" :rows="3" placeholder="请输入商品描述" clearable />
              </el-form-item>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="商品状态" prop="status">
                  <el-radio-group v-model="forms.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="0">禁用</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>
        </el-tab-pane>
        <el-tab-pane label="规格信息" name="skus">
          <div class="sku-toolbar">
            <el-button type="primary" @click="addSku" size="small">新增规格</el-button>
          </div>
          <el-table :data="skuList" border style="width: 100%; margin-top: 10px;" size="small">
            <el-table-column prop="skuCode" label="规格编号" width="180" />
            <el-table-column prop="attributes" label="规格属性" width="200">
              <template #default="scope">
                <el-input v-model="scope.row.attributes" placeholder="请输入规格属性" />
              </template>
            </el-table-column>
            <el-table-column prop="originPrice" label="原价" width="180">
              <template #default="scope">
                <el-input-number v-model="scope.row.originPrice" :precision="2" :step="0.1" :min="0" style="width: 160px;" />
              </template>
            </el-table-column>
            <el-table-column prop="sellPrice" label="售价" width="180">
              <template #default="scope">
                <el-input-number v-model="scope.row.sellPrice" :precision="2" :step="0.1" :min="0" style="width: 160px;" />
              </template>
            </el-table-column>
            <el-table-column prop="stockNum" label="库存" width="180">
              <template #default="scope">
                <el-input-number v-model="scope.row.stockNum" :min="0" style="width: 160px;" />
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" fixed="right">
              <template #default="scope">
                <el-button type="danger" link @click="removeSku(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </static-dialog>

    <!-- 添加图片编辑对话框 -->
    <el-dialog v-model="imageDialogVisible" title="编辑商品图片" width="60%">
      <el-form :model="imageForm" label-width="100px">
        <el-form-item label="商品编号">
          <el-input v-model="imageForm.productCode" disabled></el-input>
        </el-form-item>
        <el-form-item label="商品主图">
          <el-upload 
            :headers="uploadHeaders"
            :action="apiUrl + 'ShopProduct/Uploader?dataType=main&productCode=' + imageForm.productCode"
            list-type="picture-card" 
            :auto-upload="true" 
            :on-success="uploadHandleSuccess"
            :on-remove="handleRemove"
            :on-preview="handlePictureCardPreview"
            :file-list="mainImages" 
            :limit="5" 
            multiple>
            <template #default>
              <el-icon><Plus /></el-icon>
            </template>
          </el-upload>
          <el-dialog v-model="dialogVisible">
            <img w-full :src="dialogImageUrl" alt="Preview Image" style="max-width: 100%;" />
          </el-dialog>
        </el-form-item>
        <el-form-item label="详情图">
          <el-upload 
            :headers="uploadHeaders"
            :action="apiUrl + 'ShopProduct/Uploader?dataType=detail&productCode=' + imageForm.productCode"
            list-type="picture-card" 
            :auto-upload="true" 
            :on-success="uploadHandleSuccess"
            :on-remove="handleRemove"
            :on-preview="handlePictureCardPreview"
            :file-list="detailImages" 
            :limit="5" 
            multiple>
            <template #default>
              <el-icon><Plus /></el-icon>
            </template>
          </el-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="imageDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveImages">确定</el-button>
        </span>
      </template>
    </el-dialog>

  </el-card>
</template>
<script>
import { fetchFileList, delFile } from "@/api/basic";
import {
  fetchShopList,
  fetchShopDetail,
  addproduct,
  delShopinfo,
  fetchShopMenus,
  fetchShopProductCode,
  submitShopinfo,
  fetchShopCode,
  delShopFile,
  fetchShopImageList,
  deleteShopImage,
  getPrevID
} from "@/api/shop";
import StaticDialog from "@/components/static-dialog.vue";
import BasicTable from "@/components/basic-table.vue";
export default {
  name: "shoproduct",
  components: { StaticDialog, BasicTable },
  data() {
    return {
      apiUrl: '',
      productCode: "",
      isEdit: false,
      tableData: [], // 表格数据
      uploadHeaders: {
        Authorization: `Bearer ${sessionStorage.getItem('access_token') || ''}`
      },
      querys: {
        keyword: "",
        filters: [],
        columns: [
          { prop: "createUserName", label: "创建人", sortable: true, searchable: true, width: "80" },
          { prop: "createDate", label: "创建时间", sortable: true, width: "140", showOverflowTooltip: true },
          { prop: "categoryID", label: "商品类别", sortable: true, searchable: true, width: "120", showOverflowTooltip: true },
          { prop: "productName", label: "商品名称", sortable: true, searchable: true, width: "300", showOverflowTooltip: true },
          { prop: "productCode", label: "商品编号", sortable: true, searchable: true, width: "90", showOverflowTooltip: true },
          { prop: "labelPrice", label: "标签价格", sortable: true, width: "90", showOverflowTooltip: true },
          { prop: "sellPrice", label: "销售价格", sortable: true,  width: "90", showOverflowTooltip: true },
          { prop: "originalNum", label: "商品库存", sortable: true, width: "90", showOverflowTooltip: true },
          { prop: "productDesc", label: "商品描述", sortable: true,  width: "90", showOverflowTooltip: true },
          { prop: "startDate", label: "上架时间", sortable: true, searchable: true, width: "150", showOverflowTooltip: true },
          { prop: "endDate", label: "下架时间", sortable: true, searchable: true, width: "150", showOverflowTooltip: true }
        ],
        sidx: "id",
        sord: "descending",
        page: 1,
        rows: 10,
        records: 0,
      },
      currRow: null,
      selectedRow: null, // 当前选中的行
      centerDialogVisible: false,
      dialogWidth: "30%",

      dict: {
        categorys: [],
        brands: [],
        factorys: [],
      },
      forms: {},
      labelWidth: "110px",
      rules: {
        categoryID: [
          { required: true, message: '请选择商品类别', trigger: 'change' }
        ],
        productCode: [
          { required: true, message: '请输入商品编码', trigger: 'blur' }
        ],
        productName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: '请选择上架开始时间', trigger: 'change' },
          { 
            validator: (rule, value, callback) => {
              if (value && this.forms.endDate && value >= this.forms.endDate) {
                callback(new Error('上架开始时间必须早于结束时间'));
              } else {
                callback();
              }
            }, 
            trigger: 'change'
          }
        ],
        endDate: [
          { required: true, message: '请选择上架结束时间', trigger: 'change' },
          { 
            validator: (rule, value, callback) => {
              if (value && this.forms.startDate && value <= this.forms.startDate) {
                callback(new Error('上架结束时间必须晚于开始时间'));
              } else {
                callback();
              }
            }, 
            trigger: 'change'
          }
        ],
        status: [
          { required: true, message: '请选择商品状态', trigger: 'change' }
        ]
      },
      //fileList:[{name: 'food.jpg', url: 'https://xxx.cdn.com/xxx.jpg'}]
      fileList: [],
      categoryAttributeOptions: [],
      categoryData: [], // 保存fetchShopMenus的原始数据
      imageDialogVisible: false,
      imageForm: {
        productCode: '',
        main: [],
        detail: []
      },
      activeTab: 'basic',
      skuList: [],
      mainImages: [],  // 商品主图列表
      detailImages: [], // 商品详情图列表
      dialogImageUrl: '',
      dialogVisible: false,
    };
  },
  mounted() {
    this.fetchs();

    this.apiUrl = process.env.VUE_APP_BASEURL;
    // 初始加载分类数据
    this.loadCategoryData();
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '新增商品' : '编辑商品';
    }
  },
  methods: {
    // 加载子节点数据
    loadChild(row, treeNode, resolve) {
      fetchShopCode(row.id).then(res => {
        if (res.code === 200 && res.data) {
          // 将skus数据转换为表格行数据
          const children = res.data.skus.map(sku => ({
            ...sku,
            productName: res.data.spu.productName,
            labelPrice: sku.originPrice,
            sellPrice: sku.sellPrice,
            originalNum: sku.stockNum,
            isLeaf: true // 标记为叶子节点
          }));
          resolve(children);
        } else {
          resolve([]);
        }
      }).catch(() => {
        resolve([]);
      });
    },

    // 刷新已展开的节点
    refreshExpandedNodes() {
      this.$nextTick(() => {
        // 强制刷新表格，重新加载所有数据
        this.fetchs();
      });
    },

    add() {
      this.currRow = {};
      this.$refs.dialog.toggle();
      this.isEdit = true
      this.skuList = [];
    },
    // 编辑按钮点击事件
    edit(row) {
      if (!row) {
        this.$message({
          type: 'warning',
          message: '请先选择要编辑的商品'
        });
        return;
      }
      
      // 检查是否选中了SKU（叶子节点）
      if (row.isLeaf) {
        this.$message({
          type: 'warning',
          message: '请选择商品主数据（SPU）进行编辑，不能编辑商品规格（SKU）'
        });
        return;
      }
      
      this.currRow = row;
      this.isEdit = false;
      this.$refs.dialog.toggle();
      
      // 获取SPU和SKUs数据
      fetchShopCode(row.id).then(res => {
        if (res.code === 200 && res.data) {
          // 设置SPU数据
          this.forms = { 
            ...res.data.spu,
            status: Number(res.data.spu.status) // 确保status是数字类型
          };
          // 设置SKUs数据
          this.skuList = res.data.skus || [];
        }
      });
    },
    del(row) {
      if (!row) {
        this.$message({
          type: 'warning',
          message: '请先选择要删除的商品'
        });
        return;
      }
      
      // 检查是否选中了SKU（叶子节点）
      if (row.isLeaf) {
        this.$message({
          type: 'warning',
          message: '请选择商品主数据（SPU）进行删除，不能删除商品规格（SKU）'
        });
        return;
      }
      
      this.currRow = row;
      let that = this;

      this.$confirm("此操作将删除本行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delShopinfo(that.currRow.id).then((res) => {
          that.$message({
            type: res.type,
            message: res.content,
          });
          that.fetchs();
          that.selectedRow = null; // 删除后清空选中状态
        });
      });
    },
    chooseOption(value) {
      // 参数映射表
      const codeMap = [
        "AA", "BB", "CC", "DD", "EE", "FF", "GG", "HH", "II", "JJ",
        "KK", "LL", "MM", "NN", "OO", "PP", "QQ", "RR", "SS", "TT",
        "UU", "VV", "WW", "XX", "YY", "ZZ"
      ];

      // 找到当前选择的类别
      const selectedCategory = this.categoryData.find(item => item.id === value);
      if (!selectedCategory) return;

      // 找到当前选项的索引
      const idx = this.categoryData.indexOf(selectedCategory);
      // 取出对应的参数
      const param = codeMap[idx] || "ZZ";
      
      fetchShopProductCode(param).then((res) => {
        this.forms.productCode = res.data;
      });
    },
    collectCategoryAttributes(data) {
      const attrs = [];
      if (!Array.isArray(data)) return attrs;
      const traverse = (nodes) => {
        nodes.forEach(node => {
          // attribute为空则用name
          const attr = node.attribute || node.name;
          if (attr && !attrs.includes(attr)) {
            attrs.push(attr);
          }
          if (node.children && node.children.length > 0) {
            traverse(node.children);
          }
        });
      };
      traverse(data);
      return attrs;
    },
    // 添加统一的获取商品类别方法
    loadCategoryData() {
      return fetchShopMenus().then((res) => {
        let data = JSON.parse(JSON.stringify(res));
        this.categoryData = Array.isArray(data) ? data : [];
        return this.categoryData;
      });
    },

    opened() {
      let that = this;
      this.forms = {};
      // 使用统一的方法获取类别数据
      this.loadCategoryData().then(() => {
        if (this.currRow && this.currRow.id) {
          fetchShopDetail(this.currRow.id).then((res) => {
            that.forms = { ...res.data };
          });

          fetchFileList(this.currRow.id, this.currRow.productCode).then((res) => {
            that.fileList = [];
            res.data.forEach(function (item) {
              that.fileList.push({ id: item.id, name: item.name, url: that.apiUrl.substr(0, that.apiUrl.length - 1) + item.path });
            })
          });
        }
      });
    },
    submit() {
      let that = this;
      this.$refs.forms.validate((valid) => {
        if (!valid) return;
        // 新增时校验skuList必填
        if (that.isEdit && (!that.skuList || that.skuList.length === 0)) {
          that.$message({
            type: 'warning',
            message: '请至少添加一个产品规格信息！'
          });
          that.activeTab = 'skus';
          return;
        }

        const params = {
          spu: {
            productName: this.forms.productName,
            productCode: this.forms.productCode,
            status: this.forms.status,
            startDate: this.forms.startDate,
            endDate: this.forms.endDate,
            categoryID: this.forms.categoryID,
            description: this.forms.productDesc
          },
          skus: this.skuList.map(sku => {
            // 统一SKU数据格式
            const skuData = {
              attributes: sku.attributes || '',
              originPrice: sku.originPrice || 0,
              sellPrice: sku.sellPrice || 0,
              skuCode: sku.skuCode || '',
              status: sku.status || 1,
              stockNum: sku.stockNum || 0
            };

            // 如果是编辑状态且SKU有ID，则保留ID
            if (!this.isEdit && sku.id) {
              skuData.id = sku.id;
            }

            return skuData;
          })
        };

        if (that.isEdit) {
          addproduct(params).then((res) => {
            that.$message({
              type: res.type,
              message: res.content,
            });
            if (res.code == 200) {
              that.refreshExpandedNodes();
              that.$refs.dialog.toggle();
            }
          });
        } else {
          submitShopinfo((that.currRow.id || ''), params).then((res) => {
            that.$message({
              type: res.type,
              message: res.content,
            });
            if (res.code == 200) {
              that.refreshExpandedNodes();
              that.$refs.dialog.toggle();
            }
          });
        }
      });
    },
    // 搜索方法，重置分页到第一页
    search() {
      this.querys.page = 1;
      this.fetchs();
    },
    fetchs() {
      this.querys.filters = [];
      if (this.productCode)
        this.querys.filters.push({
          name: "productCode",
          value: "%" + this.productCode.trim() + "%",
          operate: 5,
        });
      let { data, records, total, ...search } = {
        ...this.querys,
      };

      fetchShopList(search).then((res) => {
        if (res.data) {
          this.tableData = (res.data.data || []).map(item => ({
            ...item,
            hasChildren: true
          }));
          this.querys.records = res.data.records || 0;
        }
      });
    },
    currHandler(row) {
      this.currRow = row;
    },
    // 处理行选中事件
    handleCurrentChange(currentRow) {
      this.selectedRow = currentRow;
    },
    pageHandler(page) {
      this.querys.page = page;
      this.fetchs();
    },
    sizeHandler(rows) {
      this.querys.rows = rows;
      this.querys.page = 1; // 改变每页显示数量时，重置到第一页
      this.fetchs();
    },
    sortHandler(order) {
      this.querys.sidx = order.prop;
      this.querys.sord = order.order;
      this.fetchs();
    },
    //控制dialog宽度与子组件控制关闭弹窗
    getdialogWidth(data) {
      if (data === "80%" || data === "30%") {
        this.dialogWidth = data;
      } else {
        this.centerDialogVisible = false;
      }
    },

    uploadHandleBefore(file) {
      console.log(file)
      console.log(this.forms.productCode, 'file.id666')
      if (!this.forms.id || !this.forms.productCode)
        return false;
    },
    uploadHandleRemove(file, fileList) {
      console.log(file.id, fileList)
      delFile(file.id).then((res) => {
        that.$message({
          type: res.type,
          message: res.content,
        });
      });
    },
    uploadHandleSuccess(res, file, fileList) {
      console.log(res, file, fileList)
      this.$message({
        type: res.type,
        message: res.content,
      });

      if (res.code != 200) {
        fileList = fileList.pop()
      }
    },
    detailHandleImageChange(file, fileList) {
      fileList.forEach(item => {
        item.url = item.response ? item.response.data.tostringss() : ''; // 确保每个文件都有url属性
      });
      this.form.detail = fileList;
    },
    detailHandleRemove(file) {
      console.log(res, file, fileList)
      this.$message({
        type: res.type,
        message: res.content,
      });

      if (res.code != 200) {
        fileList = fileList.pop()
      }
    },
    // 获取分类的attribute
    getCategoryAttribute(categoryID) {
      if (!categoryID || !this.categoryData) return '';
      
      // 递归查找categoryID对应的attribute
      const findAttribute = (nodes, targetId) => {
        for (let node of nodes) {
          if (node.id === targetId) {
            return node.attribute || node.name;
          }
          if (node.children && node.children.length > 0) {
            const found = findAttribute(node.children, targetId);
            if (found) return found;
          }
        }
        return null;
      };
      
      const attribute = findAttribute(this.categoryData, categoryID);
      return attribute || categoryID;
    },
    // 编辑图片按钮点击事件
    editImages(row) {
      if (!row) {
        this.$message({
          type: 'warning',
          message: '请先选择要编辑图片的商品'
        });
        return;
      }
      
      // 检查是否选中了SKU（叶子节点）
      if (row.isLeaf) {
        this.$message({
          type: 'warning',
          message: '请选择商品主数据（SPU）进行图片编辑，不能编辑商品规格（SKU）的图片'
        });
        return;
      }
      
      if (!row.productCode) {
        this.$message({
          message: '无法获取商品信息',
          type: 'warning'
        });
        return;
      }
      
      this.imageForm.productCode = row.productCode;
      // 获取商品图片列表
      fetchShopImageList(row.productCode).then((res) => {
        if (res.code === 200 && res.data) {
          // 分离主图和详情图
          this.mainImages = res.data.filter(img => img.dataType === 'main').map(img => ({
            id: img.id,
            name: img.id + '.' + img.fileExtensions,
            filePath: img.filePath,
            url: this.apiUrl.substr(0, this.apiUrl.length - 1) + img.filePath
          }));
          
          this.detailImages = res.data.filter(img => img.dataType === 'detail').map(img => ({
            id: img.id,
            name: img.id + '.' + img.fileExtensions,
            filePath: img.filePath,
            url: this.apiUrl.substr(0, this.apiUrl.length - 1) + img.filePath
          }));
        }
        this.imageDialogVisible = true;
      });
    },

    // 保存图片配置
    saveImages() {
      this.imageDialogVisible = false;
      this.$message({
        message: '图片配置已保存',
        type: 'success'
      });
      this.fetchs(); // 刷新列表
    },

    // 新增SKU
    addSku() {
      const newSku = {
        productID: this.forms.id,
        skuCode: '',  // 新增时SKU编号为空
        attributes: '',
        originPrice: 0,
        sellPrice: 0,
        stockNum: 0,
        status: 1
      };
      this.skuList.push(newSku);
    },

    // 删除SKU
    removeSku(index) {
      const sku = this.skuList[index];
      if (sku.id) {
        // 如果是已存在的SKU，添加删除标记
        this.$confirm('确认删除该规格?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 构造编辑参数
          const params = {
            spu: {
              productName: this.forms.productName,
              productCode: this.forms.productCode,
              status: this.forms.status,
              startDate: this.forms.startDate,
              endDate: this.forms.endDate,
              categoryID: this.forms.categoryID,
              description: this.forms.productDesc
            },
            skus: this.skuList.map((item, i) => {
              if (i === index) {
                // 为要删除的SKU只保留必要字段并添加删除标记
                return {
                  attributes: item.attributes,
                  originPrice: item.originPrice,
                  sellPrice: item.sellPrice,
                  skuCode: item.skuCode,
                  status: item.status,
                  stockNum: item.stockNum,
                  id: item.id,
                  deleteMark: true
                };
              }
              // 其他SKU保持不变
              return {
                attributes: item.attributes,
                originPrice: item.originPrice,
                sellPrice: item.sellPrice,
                skuCode: item.skuCode,
                status: item.status,
                stockNum: item.stockNum,
                id: item.id
              };
            })
          };

          // 调用编辑接口
          submitShopinfo(this.currRow.id, params).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '删除成功'
              });
              // 从列表中移除该SKU
              this.skuList.splice(index, 1);
              // 刷新表格数据，包括已展开的节点
              this.refreshExpandedNodes();
            } else {
              this.$message({
                type: 'error',
                message: res.content || '删除失败'
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      } else {
        // 如果是新增的SKU，直接从列表中移除
        this.skuList.splice(index, 1);
      }
    },

    // 修改上传成功处理函数
    uploadHandleSuccess(res, file, fileList) {
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: res.content
        });
        // 重新获取图片列表
        fetchShopImageList(this.imageForm.productCode).then((res) => {
          if (res.code === 200 && res.data) {
            // 更新图片列表
            this.mainImages = res.data.filter(img => img.dataType === 'main').map(img => ({
              id: img.id,
              name: img.id + '.' + img.fileExtensions,
              filePath: img.filePath,
              url: this.apiUrl.substr(0, this.apiUrl.length - 1) + img.filePath
            }));
            
            this.detailImages = res.data.filter(img => img.dataType === 'detail').map(img => ({
              id: img.id,
              name: img.id + '.' + img.fileExtensions,
              filePath: img.filePath,
              url: this.apiUrl.substr(0, this.apiUrl.length - 1) + img.filePath
            }));
          }
        });
      } else {
        this.$message({
          type: 'error',
          message: res.content
        });
        fileList.pop();
      }
    },

    // 修改删除文件处理函数
    handleRemove(file) {
      if (file.id) {
        this.$confirm('确认删除该图片?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteShopImage(file.id).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '删除成功'
              });
              // 重新获取图片列表
              fetchShopImageList(this.imageForm.productCode).then((res) => {
                if (res.code === 200 && res.data) {
                  // 更新图片列表
                  this.mainImages = res.data.filter(img => img.dataType === 'main').map(img => ({
                    id: img.id,
                    name: img.id + '.' + img.fileExtensions,
                    filePath: img.filePath,
                    url: this.apiUrl.substr(0, this.apiUrl.length - 1) + img.filePath
                  }));
                  
                  this.detailImages = res.data.filter(img => img.dataType === 'detail').map(img => ({
                    id: img.id,
                    name: img.id + '.' + img.fileExtensions,
                    filePath: img.filePath,
                    url: this.apiUrl.substr(0, this.apiUrl.length - 1) + img.filePath
                  }));
                }
              });
            } else {
              this.$message({
                type: 'error',
                message: res.content || '删除失败'
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="less">
.xlsdialog {
  .el-dialog__body {
    max-height: 80vh;
    overflow-y: auto;
  }
}

.el-form .el-date-editor {
  width: 220px;
}
// .toolbar {
//   margin-bottom: 20px;
//   display: flex;
//   align-items: center;
// }
.sku-toolbar {
  margin-bottom: 20px;
}
</style>>
